/* A swipe changes slides, it must not also follow the whole-slide link. */
(() => {
  const bindSlideLinks = (root = document) => {
    root.querySelectorAll('hero-slideshow.hero').forEach((hero) => {
      if (hero.dataset.slideLinksReady === 'true') return;
      hero.dataset.slideLinksReady = 'true';
      let gesture = null;
      let blockedUntil = 0;
      hero.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
      }, { passive: true });
      hero.addEventListener('pointermove', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) gesture.moved = true;
      }, { passive: true });
      hero.addEventListener('pointerup', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        if (gesture.moved || Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) {
          blockedUntil = performance.now() + 600;
        }
        gesture = null;
      }, { passive: true });
      hero.addEventListener('pointercancel', () => {
        if (gesture?.moved) blockedUntil = performance.now() + 600;
        gesture = null;
      }, { passive: true });
      hero.addEventListener('click', (event) => {
        const link = event.target instanceof Element && event.target.closest('[data-hero-slide-link]');
        // detail=0 is keyboard/programmatic activation, not a dragged pointer.
        if (link && event.detail !== 0 && performance.now() < blockedUntil) event.preventDefault();
      }, true);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bindSlideLinks(), { once: true });
  else bindSlideLinks();
  document.addEventListener('shopify:section:load', (event) => bindSlideLinks(event.target));
})();
